import { render, staticRenderFns } from "./AdmissionsStudentWrapper.vue?vue&type=template&id=2b102bd5"
import script from "./AdmissionsStudentWrapper.vue?vue&type=script&lang=js"
export * from "./AdmissionsStudentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports